import { render, staticRenderFns } from "./EditPaymentBasics.vue?vue&type=template&id=314da204&"
import script from "./EditPaymentBasics.vue?vue&type=script&lang=ts&"
export * from "./EditPaymentBasics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports